import { getInstance } from '../../../lib/axios';
import constants from '../../../constants';

export async function getUserCreatedWorkouts() {
  try {
    const url = `${constants.endpoints.ADMIN_WORKOUTS_REVIEW}`;
    const response = await getInstance().get(url);
    return response.data;
  } catch (error) {
    console.error('Fetch user created workouts failed', error.message);
    throw error;
  }
}

export async function createOrDenyWorkout(data) {
  try {
    const response = await getInstance().post(constants.endpoints.ADMIN_WORKOUTS_REVIEW, data);
    return response.data;
  } catch (error) {
    console.error('Create or deny workouts failed', error.message);
    throw error;
  }
}